
import { BehavioralFactor } from '@/types/resultsTypes';
import { DCTOS_LETTERS } from '@/lib/dctos-config';

export type ChartData = {
  name: string;
  fullName: string;
  value: number;
  color: string;
};

export function factorsToChartData(factors: BehavioralFactor[] = []): ChartData[] {
  // DCTOS order: D (Drive), C (Connection), T (Task), O (Order), S (Style)
  // Factors are expected in order: dominance, extraversion, patience, formality, objectivity
  return (factors || []).map((factor, idx) => ({
    name: DCTOS_LETTERS[idx] || String.fromCharCode(65 + idx),
    fullName: factor.name,
    value: factor.percentile,
    color: factor.color,
  }));
}
